import { Component, Input } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgStyle } from '@angular/common';
import { IceCardComponent } from '../../atoms/ice-card/ice-card.component';

@Component({
  selector: 'app-ice-alert',
  templateUrl: 'ice-alert.component.html',
  styleUrls: ['./ice-alert.component.scss'],
  imports: [IceCardComponent, NgClass, NgStyle, MatIcon],
})
export class IceAlertComponent {
  @Input() iconName: IconNames;
  @Input() iconWidth = '1.5rem';
  @Input() iconHeight = '';
  @Input() isClickable: boolean = false;
  @Input() padding: string = '1rem';
  @Input() type: 'regular' | 'success' | 'error' | 'critical' | 'warning' | 'neutral' | 'info' = 'regular';
}
